import styles from "./DatasetTag.module.scss";
import React from "react";
import { Tag } from "antd";
import classNames from "classnames";
import Icon, { RightOutlined } from "@ant-design/icons";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import {useAppSelector} from "../../hooks";
import {selectDatasets} from "./glossarySlice";
import {GlossaryDataset} from "../../actions/api";

const CircleSVG = () => <svg fill="currentColor" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="55" r="30" />
</svg>

const TagIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={CircleSVG} {...props} />
);

export type DatasetTagProps = {
    title: string,
    colourIndex?: number,
    className?: string,
    selected ?: boolean,
    size?: "m" | "s"
}

export const DatasetTags = ({datasets}: {datasets: GlossaryDataset[]}) => {
    const allDatasets: Record<number, GlossaryDataset & {index: number}> = (useAppSelector(selectDatasets) ?? [])
        .reduce((acc, dataset, index) => {
            return {
                ...acc,
                [dataset.id]: {...dataset, index}
            }
    }, {})

    if (datasets.length > 0) {
        return <p>
            {[...datasets]
                .sort((a, b) => a.title.localeCompare(b.title))
                .map((dataset, index) => {
                return <React.Fragment key={dataset.id}>
                    <DatasetTag
                        title={dataset.title}
                        colourIndex={allDatasets[dataset.id]?.index}
                        size="s"
                        className={index === 0 ? styles['align-left'] : undefined}
                    />
                </React.Fragment>
            })}
        </p>
    }

    return null
}

export const DatasetTag = ({title, colourIndex, className, selected, size}: DatasetTagProps) => {
    return <Tag
        className={classNames(styles['tag'], className, {[styles['small']]: size === "s"})}
        icon={colourIndex === undefined ?
            undefined :
            <TagIcon className={classNames(styles['tag-icon'], styles[`tag-${colourIndex}`])}/>}
    >
        {title}
        { selected ? <RightOutlined className={styles['selected-arrow']}/> : undefined }
    </Tag>
}